import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/logo.png'
import _imports_1 from '../assets/img/title.png'
import _imports_2 from '../assets/img/start_btn.png'
import _imports_3 from '../assets/img/agree_icon.png'
import _imports_4 from '../assets/img/foot_text.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-9953568c")

_pushScopeId("data-v-9953568c")
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "logo",
  alt: "封面新闻"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "title",
  alt: "逆时光之流"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 我同意封面新闻客户端使用我的历史数据用以生成《封面新闻2023年度报告》 ")
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "footer" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_4,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode(" 数据截止于2023年12月 ")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("img", {
      src: _imports_2,
      class: ["start", _ctx.agree ? 'agree-hover' : ''],
      alt: "开始回顾",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleStart && _ctx.handleStart(...args)))
    }, null, 2),
    _createVNode("div", {
      class: "agree",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleAgree && _ctx.handleAgree(...args)))
    }, [
      _createVNode("img", {
        src: _imports_3,
        class: _ctx.agree ? 'agree-hover' : '',
        alt: ""
      }, null, 2),
      _hoisted_4
    ]),
    _hoisted_5
  ]))
})